(function () {
    'use strict';

    angular.module('app')
        .factory('CategoriaRss', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "categorias-rss";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();
